// import globalSocket from "../classes/socket/mainSocket/GlobalSocket";
// import { _get, _isEmpty } from "../utils/helpers/zupeeLodash";
// import { getGameplaySpEventData, getToken, parseString } from "../utils/helpers/common";
// import { destroySocket, initializeGameplaySocket } from "../classes/socket/gameplay";
// import { JOIN_TOURNAMENT_TABLE } from "../utils/helpers/constants";

import { getToken } from "../../../utils/helpers/common";
import { _isEmpty } from "../../../utils/helpers/zupeeLodash";
import { parseString } from "../../../utils/helpers/common";
import { getGameplaySpEventData } from "../../../utils/helpers/common";
import { JOIN_TOURNAMENT_TABLE } from "../../../utils/helpers/constants";
import { _get } from "../../../utils/helpers/zupeeLodash";
import { destroySocket, initializeGameplaySocket } from "../gameplay";
import globalSocket from "./GlobalSocket";
import { logout } from "../../../storage/tokenState";
import { refreshWithdrawStatus } from "../../../utils/withdrawStatusRefresh";

interface SocketHandlerProps {
  onLogout: () => void;
  new_login?: boolean;
  number?: string;
  otp?: string;
}

export const initializeGlobalSocket = (
  postSignupConfig: any,
  socketHandlerProps: SocketHandlerProps,
) => {
  const params = {...socketHandlerProps, ...postSignupConfig}
  const handleLogout = () => {
    console.log("handleLogout")
    // setLoading(true);
    logout();
  }
  const handleSocketData = (res: any) => {
    switch (res.en) {
      case "CONNECTION_MANAGE": {
        handleAppClose();
        setTimeout(() => {
          handleLogout();
          // socketHandlerProps.onLogout();
        }, 1000);
        break;
      }
      case "GAME_STARTED":
        initializeGameplaySocket(res?.data?.gameplayServer, {
          en: JOIN_TOURNAMENT_TABLE,
          data: { ltid: res?.data?.ltid },
        });
        break;
      case "REFRESH_WITHDRAW_STATUS_SCREEN":
        // Server-pushed payout update — the status screen is never polled, so
        // this is the only channel that carries it to success/fail.
        refreshWithdrawStatus(res?.data);
        break;
      default:
        break;
    }
  };

  const hitSpEvent = () => {
    console.log("hitSpEvent")
    globalSocket.emit(parseString(getGameplaySpEventData()));
  };

  const onSocketConnected = () => {
    const token = getToken();
    if (!_isEmpty(_get(token, "accessToken", ""))) {
      hitSpEvent();
    }
  };

  const handleAppClose = () => {
    globalSocket.destroy_socket();
    destroySocket();
  };

  globalSocket.initialize(params, onSocketConnected, handleSocketData);

  return {
    destroy: () => {
      globalSocket.destroy_socket();
    }
  };
};